<template>
  <v-col cols="12" sm="10" md="8" lg="6" class="pl-0 py-0 mt-2">
    <p class="mb-2">
      Выгрузка плана набора с sip_settings домофона
    </p>
    <v-btn
      large
      :disabled="doorphone.length === 0"
      color="success"
      class="text-none"
      @click="getApartmentSip()"
    >
      Получить
    </v-btn>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cp1251Encode from '@/mixins/cp1251Encode';

export default {
  name: 'UnloadingSipSettingsDoorphone',
  mixins: [cp1251Encode],
  props: {
    doorphone: Array,
  },
  data: () => ({
    isCreated: false,
    idDoorphone: null,
    filterAbonents: {},
    ruleAndSipSettings: [],
    combinedData: [],
    includeAbonents: ['apartmentSipSettings'],
  }),
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/doorphones',
    }),
  },
  methods: {
    ...mapActions({
      showRuleSipSettings: 'Doorphone/showRuleSipSettings',
    }),
    async getApartmentSip () {
      await this.showRuleSipSettings(this.doorphone[0].id)
        .then((data) => {
          this.ruleAndSipSettings = data;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка');
          }
        });
      await this.prepareCombinedData();
    },
    prepareCombinedData () {
      const filteredSipSettings = [];
      this.ruleAndSipSettings.apartment_sip_settings.forEach(item => {
        filteredSipSettings.push({ login: item.login.split('@')[0], sip_password: item.sip_password });
      });

      const combinedData = this.ruleAndSipSettings.rules.data.map(item => {
        let found = null;

        if (this.doorphone[0].model === 'RV-3434') {
          if (item.Login) {
            const login = item.Login.split(';')[0];
            found = filteredSipSettings.find(value => value.login === login);
          }
        } else if (this.doorphone[0].model === 'RV-3438') {
          if (item.Replace) {
            found = filteredSipSettings.find(value => value.login === item.Replace);
          }
        } else {
          if (item.Phone1) {
            found = filteredSipSettings.find(value => value.login === item.Phone1);
          }
        }
        return {
          ...item,
          sip_password: found ? found.sip_password : null,
        };
      });
      this.downloadFile(combinedData);
    },
    downloadFile (combinedData) {
      const lines = [];
      const address = this.doorphone[0].address + ', п. ' + this.doorphone[0].entrance;
      combinedData.forEach((item) => {
        let line;
        let login = item.Login;

        if (login && login.includes(';')) {
          login = login.split(';')[0];
        }
        if (this.doorphone[0].model === 'RV-3434') {
          line = [
            address, item.Prefix, login, item.sip_password,
          ].join(';');
        } else if (this.doorphone[0].model === 'RV-3438') {
          line = [
            address, item.Prefix, item.Replace, item.sip_password,
          ].join(';');
        } else {
          line = [
            address, item.Number, item.Phone1, item.sip_password,
          ].join(';');
        }
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = `apartment_sip_intercom_${this.doorphone[0].id}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
